// Reveal-on-scroll, header shade, accordions, craft list highlight.
(function () {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });

  function init(root) {
    (root || document).querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }
  init(document);

  // Same on every template: a flat full-width bar at the top, condensing into
  // the floating pill past 40px. Adding .is-stuck at load on non-home pages put
  // the pill on screen before the reader had scrolled anything.
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Phone menu: a full-screen translucent sheet (CSS does the animation).
  function setNav(open) {
    var nav = document.querySelector('.header__nav');
    var btn = document.querySelector('.header__burger');
    if (!nav) return;
    document.body.classList.toggle('nav-open', open);
    nav.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('nav-open')) setNav(false);
  });
  window.matchMedia('(min-width:1001px)').addEventListener('change', function (m) { if (m.matches) setNav(false); });

  document.addEventListener('click', function (e) {
    var burger = e.target.closest('.header__burger');
    if (burger) {
      setNav(!document.body.classList.contains('nav-open'));
      return;
    }
    if (e.target.closest('.header__nav a') && document.body.classList.contains('nav-open')) setNav(false);
    var accBtn = e.target.closest('.acc__btn');
    if (accBtn) {
      var acc = accBtn.closest('.acc');
      var open = acc.classList.toggle('is-open');
      accBtn.setAttribute('aria-expanded', open);
      return;
    }
  });

  // Theme editor re-renders sections without a page reload.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initCraft(e.target); });

  // ---------- craft: stacked scroll panels ----------
  // Each step owns a tall sentinel. A step goes active the moment its sentinel
  // reaches the top of the viewport (which is also when the sticky stage takes
  // over for it), and the scroll travelled inside that sentinel is mapped onto
  // the step's video playhead — the clip is seeked, never played. The video is
  // done at `scrub_end`% of the sentinel; the remaining scroll is dead space so
  // the last frame holds before the next panel slides up.
  function initCraft(root) {
    (root || document).querySelectorAll('[data-craft]').forEach(function (craft) {
      if (craft.dataset.craftReady) return;
      craft.dataset.craftReady = '1';

      var sentinels = [].slice.call(craft.querySelectorAll('[data-craft-sentinel]'));
      if (sentinels.length < 2) return;

      var bgs = craft.querySelectorAll('[data-craft-bg]');
      var cards = craft.querySelectorAll('[data-craft-card]');
      var items = craft.querySelectorAll('[data-craft-jump]');
      var videos = {};
      craft.querySelectorAll('[data-craft-video]').forEach(function (v) {
        videos[v.dataset.craftVideo] = v;
      });
      var scrubEnd = (Number(craft.dataset.craftScrub) || 85) / 100;
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = -1;
      var queued = false;

      function setStep(i) {
        if (i === current) return;
        current = i;
        // layers before the active one stay up; later ones wait below the fold
        bgs.forEach(function (n, k) {
          n.classList.toggle('is-active', k === i);
          n.classList.toggle('is-past', k < i);
        });
        cards.forEach(function (n, k) { n.classList.toggle('is-active', k === i); });
        items.forEach(function (n, k) { n.classList.toggle('is-active', k === i); });
        // wake the decoder for the panel now on screen: some browsers hold the
        // poster and never paint a seek on a video that has never played
        var v = videos[i];
        if (v && !still && !v.dataset.kicked) {
          v.dataset.kicked = '1';
          v.preload = 'auto';
          var kick = v.play();
          if (kick && kick.then) kick.then(function () { v.pause(); }).catch(function () {});
          else v.pause();
        }
      }

      function seek(i, p) {
        var v = videos[i];
        if (!v || !v.duration || v.seeking) return;
        // the very last frame is never reachable — stop 1/30s short
        var t = Math.min(v.duration - 0.033, p * v.duration);
        if (Math.abs(t - v.currentTime) < 0.02) return;
        v.currentTime = t;
      }

      function paint() {
        queued = false;
        var active = 0;
        var p = 0;
        for (var i = 0; i < sentinels.length; i++) {
          var rect = sentinels[i].getBoundingClientRect();
          if (rect.top > 0) break;              // not reached yet
          active = i;
          p = rect.height ? Math.min(1, -rect.top / rect.height) : 0;
        }
        setStep(active);
        if (!still) seek(active, Math.min(1, p / scrubEnd));
      }

      function onScroll() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(paint);
      }

      // Reduced motion: the sentinels are display:none (zero rects), so there is
      // nothing to measure — show the first panel and stop.
      if (still) { setStep(0); return; }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      // a seek landing after the scroll moved on gets the next one straight away
      craft.querySelectorAll('[data-craft-video]').forEach(function (v) {
        v.addEventListener('loadedmetadata', onScroll);
        v.addEventListener('seeked', onScroll);
      });
      paint();
    });
  }
  initCraft(document);

  // ---------- frame spotlight ----------
  // One timer per card, paused on hover/focus and while off-screen so the
  // gradient transition is never mid-flight when nobody is looking.
  function initSpot(root) {
    (root || document).querySelectorAll('[data-spot]').forEach(function (spot) {
      if (spot.dataset.spotReady) return;
      spot.dataset.spotReady = '1';

      var arts = spot.querySelectorAll('[data-spot-art]');
      var copies = spot.querySelectorAll('[data-spot-copy]');
      var dots = spot.querySelectorAll('[data-spot-go]');
      if (arts.length < 2) return;

      var wait = (Number(spot.dataset.spot) || 0) * 1000;
      var timer = null;
      var paused = false;
      var i = 0;

      spot.style.setProperty('--wait', (wait || 0) / 1000 + 's');
      spot.classList.toggle('spot--static', !wait);

      // The bar and the timer have to be started by the same call, or they drift:
      // resuming after a pause restarts the timeout from full while a paused CSS
      // animation would carry on from where it stopped.
      function restartFill() {
        dots.forEach(function (d) {
          var fill = d.querySelector('[data-spot-fill]');
          if (!fill) return;
          fill.style.animation = 'none';
          void fill.offsetWidth;          // reflow — re-adding a class will not replay a running animation
          fill.style.animation = '';
        });
      }

      function show(n) {
        i = (n + arts.length) % arts.length;
        arts.forEach(function (a, k) { a.classList.toggle('is-on', k === i); });
        copies.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-on', k === i);
          d.setAttribute('aria-selected', k === i);
        });
        restartFill();
        spot.style.setProperty('--t1', arts[i].dataset.t1);
        spot.style.setProperty('--t2', arts[i].dataset.t2);
      }

      function tick() {
        clearTimeout(timer);
        if (!wait || paused) return;
        timer = setTimeout(function () { show(i + 1); tick(); }, wait);
      }

      spot.addEventListener('click', function (e) {
        var go = e.target.closest('[data-spot-go]');
        if (!go) return;
        show(Number(go.dataset.spotGo));
        tick();
      });

      function hold(on) {
        if (on === paused) return;
        paused = on;
        spot.classList.toggle('is-held', on);   // freezes the fill with the timer
        if (on) { clearTimeout(timer); return; }
        restartFill();                          // both clocks start together again
        tick();
      }

      // Swipe on phones: left for the next frame, right for the previous. Only a
      // mostly-horizontal drag counts, so scrolling the page past it still works.
      var sx = null, sy = 0;
      spot.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      spot.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        show(i + (dx < 0 ? 1 : -1));
        tick();
      }, { passive: true });

      // Pause for a real mouse hover or keyboard focus only. A tap fires a fake
      // mouseenter and focuses the dot, and neither ever ends on a phone, so
      // reacting to them froze the slider for good after the first touch.
      spot.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold(true); });
      spot.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold(false); });
      spot.addEventListener('focusin', function (e) { if (e.target.matches(':focus-visible')) hold(true); });
      spot.addEventListener('focusout', function () { hold(false); });

      new IntersectionObserver(function (entries) {
        hold(!entries[0].isIntersecting);
      }, { threshold: 0.15 }).observe(spot);

      show(0);
      tick();
    });
  }
  initSpot(document);
  document.addEventListener('shopify:section:load', function (e) { initSpot(e.target); });
})();

// ---------- prescription step (snippets/rx-fields) ----------
// Shared by the product-page lens drawer and the Galaxsee lens screen.
// AecoRx(scope, form, applies) wires the upload / enter manually / send later
// block inside `scope` and returns { check }. Every field keeps its name; the
// form's formdata event drops whatever does not apply: the whole block when
// applies() is false (zero power, frame only), the other modes' fields always.
// Uploads ride the normal cart/add.js FormData post: Shopify stores the file
// and the line item property becomes its CDN link in the order.
window.AecoRx = function (scope, form, applies) {
  var box = scope.querySelector('[data-rxm]');
  if (!box || !form) return null;
  var method = box.querySelector('[data-rx-method]');
  var fileIn = box.querySelector('[data-rx-file]');
  var drop = box.querySelector('[data-rx-drop]');
  var card = box.querySelector('[data-rx-filecard]');
  var fileErr = box.querySelector('[data-rx-fileerr]');
  var manual = Array.prototype.slice.call(box.querySelectorAll('[data-rx-field]'));
  var METHOD = { upload: 'Uploaded', manual: 'Entered manually', later: 'Will send on WhatsApp / email' };
  var TYPES = /^(image\/(jpeg|png)|application\/pdf)$/;
  var MAX = 10 * 1024 * 1024;
  var mode = 'upload';
  var thumbUrl = '';

  // power dropdowns, built here rather than as ~400 <option>s of Liquid
  box.querySelectorAll('[data-rx-range]').forEach(function (sel) {
    var r = sel.dataset.rxRange.split(',').map(Number);
    for (var i = Math.round(r[0] / r[2]); i <= Math.round(r[1] / r[2]); i++) {
      var v = i * r[2];
      var o = document.createElement('option');
      o.value = o.textContent = i === 0 ? '0.00' : (v > 0 ? '+' : '') + v.toFixed(2);
      if (i === 0) o.selected = true;
      sel.appendChild(o);
    }
  });

  function setMode(m) {
    mode = m;
    box.querySelectorAll('[data-rx-mode]').forEach(function (b) {
      var on = b.dataset.rxMode === m;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    box.querySelectorAll('[data-rx-panel]').forEach(function (p) { p.hidden = p.dataset.rxPanel !== m; });
    method.value = METHOD[m];
    fileErr.hidden = true;
  }

  function size(b) { return b >= 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB'; }

  function showFile(f) {
    fileErr.hidden = true;
    if (!f) { card.hidden = true; drop.hidden = false; return; }
    if (!TYPES.test(f.type) || f.size > MAX) {
      fileIn.value = '';
      fileErr.textContent = f.size > MAX ? 'That file is over 10 MB. Try a smaller photo or PDF.' : 'Please use a JPG, PNG or PDF.';
      fileErr.hidden = false;
      return;
    }
    var thumb = card.querySelector('[data-rx-thumb]');
    if (thumbUrl) URL.revokeObjectURL(thumbUrl);
    thumbUrl = '';
    if (f.type === 'application/pdf') {
      thumb.style.backgroundImage = '';
      thumb.textContent = 'PDF';
    } else {
      thumbUrl = URL.createObjectURL(f);
      thumb.style.backgroundImage = 'url(' + thumbUrl + ')';
      thumb.textContent = '';
    }
    card.querySelector('[data-rx-fname]').textContent = f.name;
    card.querySelector('[data-rx-fsize]').textContent = size(f.size);
    drop.hidden = true;
    card.hidden = false;
  }

  fileIn.addEventListener('change', function () { showFile(fileIn.files[0]); });
  ['dragenter', 'dragover'].forEach(function (t) {
    drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
  });
  ['dragleave', 'drop'].forEach(function (t) {
    drop.addEventListener(t, function () { drop.classList.remove('is-over'); });
  });
  drop.addEventListener('drop', function (e) {
    e.preventDefault();
    var files = e.dataTransfer && e.dataTransfer.files;
    if (!files || !files.length) return;
    try { fileIn.files = files; } catch (err) { return; }   // very old Safari: browsing still works
    showFile(files[0]);
  });

  box.addEventListener('click', function (e) {
    var m = e.target.closest('[data-rx-mode]');
    if (m) { setMode(m.dataset.rxMode); return; }
    if (e.target.closest('[data-rx-remove]')) { fileIn.value = ''; showFile(null); return; }
    var help = e.target.closest('[data-rx-help]');
    if (help) {
      var text = box.querySelector('[data-rx-helptext]');
      text.hidden = !text.hidden;
      help.setAttribute('aria-expanded', text.hidden ? 'false' : 'true');
    }
  });

  manual.forEach(function (el) {
    el.addEventListener('input', function () {
      el.classList.remove('is-bad');
      var err = (el.closest('.rxm__eye') || el.closest('.rxm__pd')).querySelector('[data-rx-err]');
      if (err) err.hidden = true;
    });
  });

  // run before leaving the step; false = stay, the reason is already on screen
  function check() {
    if (mode === 'upload') {
      var has = fileIn.files && fileIn.files.length;
      fileErr.textContent = 'Add your prescription, or choose Enter Manually or Send Later.';
      fileErr.hidden = !!has;
      if (!has) fileIn.focus();
      return !!has;
    }
    if (mode !== 'manual') return true;

    var first = null;
    function flag(el, errEl, msg) {
      el.classList.toggle('is-bad', !!msg);
      errEl.textContent = msg;
      errEl.hidden = !msg;
      if (msg && !first) first = el;
    }
    box.querySelectorAll('.rxm__eye').forEach(function (eye) {
      var axis = eye.querySelector('[data-rx-axis]');
      var v = axis.value.trim();
      var cyl = parseFloat(eye.querySelector('[data-rx-cyl]').value) || 0;
      flag(axis, eye.querySelector('[data-rx-err]'),
        v !== '' && !(/^\d{1,3}$/.test(v) && +v <= 180) ? 'Enter an axis between 0 and 180.'
        : v === '' && cyl !== 0 ? 'CYL is set, so the axis is needed (0 to 180).' : '');
    });
    var pd = box.querySelector('[data-rx-pd]');
    var p = pd.value.trim();
    flag(pd, pd.closest('.rxm__pd').querySelector('[data-rx-err]'),
      p !== '' && !(+p >= 50 && +p <= 80) ? 'Enter a PD between 50 and 80, or leave it blank.' : '');
    if (first) first.focus();
    return !first;
  }

  form.addEventListener('formdata', function (e) {
    var fd = e.formData;
    var on = applies();
    manual.forEach(function (el) {
      if (!on || mode !== 'manual' || el.value.trim() === '') fd.delete(el.name);
    });
    if (!on || mode !== 'upload' || !fileIn.files.length) fd.delete(fileIn.name);
    if (!on) fd.delete(method.name);
  });

  return { check: check };
};

// ---------- product page ----------
function initProduct() {
  var form = document.getElementById('product-form');
  if (!form) return;
  // theme editor re-renders the section on every block change: drop the old
  // run's document listeners, then wire the fresh DOM
  if (window.__pdpAc) window.__pdpAc.abort();
  var ac = window.__pdpAc = new AbortController();

  // gallery thumbs
  var main = document.getElementById('gallery-main');
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.thumb');
    if (!thumb || !main) return;
    main.removeAttribute('srcset');   // srcset wins over src, so the swap needs it gone
    main.removeAttribute('sizes');
    main.src = thumb.dataset.full;
    thumb.parentElement.querySelectorAll('.thumb').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  }, { signal: ac.signal });

  // ---------- per-shape photo sets ----------
  // Images are attached to variants in admin; `data-variants` is that list. The
  // set for a shape is every image attached to ANY variant carrying the picked
  // shape — which is how one shape ends up with six photos and another with one.
  var thumbWrap = document.querySelector('[data-thumbs]');

  // Galaxsee pager: steps through whichever thumbs are showing and keeps the
  // "n / total" in step with any thumb click.
  var pager = document.querySelector('[data-gx-pager]');
  if (pager && thumbWrap) {
    var shownThumbs = function () {
      return Array.from(thumbWrap.querySelectorAll('.thumb')).filter(function (t) { return !t.hidden; });
    };
    var activeIndex = function (list) {
      return list.findIndex(function (t) { return t.classList.contains('is-active'); });
    };
    pager.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gx-step]');
      if (!b) return;
      var list = shownThumbs();
      list[(activeIndex(list) + Number(b.dataset.gxStep) + list.length) % list.length].click();
    });
    // the thumb's own handler sits on document, so read the result a tick later
    thumbWrap.addEventListener('click', function () {
      setTimeout(function () {
        var list = shownThumbs();
        pager.querySelector('[data-gx-count]').textContent = (Math.max(0, activeIndex(list)) + 1) + ' / ' + list.length;
      }, 0);
    });
  }

  // Touch: the photo follows the finger and the neighbour slides in beside it
  // (a "ghost" img), so it can be held half-way. Release past a quarter of the
  // width, or flick, to commit; otherwise it springs back. Committing just clicks
  // the neighbour's thumb, so pager / active thumb / shape sets stay one path.
  var stage = main && main.closest('.gallery__main');
  if (stage && thumbWrap) {
    var EASE = 'transform .32s cubic-bezier(.22,.61,.36,1)';
    var drag = null;   // {x, y, t, lastX, lastT, v, lock, list, i, dir, ghost, w}
    var busy = false;
    var shown = function () {
      return Array.from(thumbWrap.querySelectorAll('.thumb')).filter(function (t) { return !t.hidden; });
    };
    var place = function (dx) {
      main.style.transform = 'translate3d(' + dx + 'px,0,0)';
      drag.ghost.style.transform = 'translate3d(' + (dx - drag.dir * drag.w) + 'px,0,0)';
    };
    stage.addEventListener('touchstart', function (e) {
      if (busy || e.touches.length > 1) return;
      var list = shown();
      if (list.length < 2) return;
      var t = e.touches[0];
      var i = list.findIndex(function (x) { return x.classList.contains('is-active'); });
      drag = { x: t.clientX, y: t.clientY, lastX: t.clientX, lastT: e.timeStamp, v: 0,
               lock: null, list: list, i: i < 0 ? 0 : i, dir: 0, ghost: null, w: stage.clientWidth };
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (!drag || e.touches.length > 1) return;
      var t = e.touches[0], dx = t.clientX - drag.x, dy = t.clientY - drag.y;
      if (!drag.lock) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        drag.lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (drag.lock === 'x') {
          drag.ghost = document.createElement('img');
          drag.ghost.className = 'gallery__ghost';
          drag.ghost.alt = '';
          main.after(drag.ghost);
          main.style.transition = 'none';
        }
      }
      if (drag.lock !== 'x') { drag = null; return; }   // vertical: let the page scroll
      e.preventDefault();
      var dir = dx < 0 ? -1 : 1;   // -1 = dragging left = next photo
      if (dir !== drag.dir) {
        drag.dir = dir;
        var n = drag.list.length;
        drag.ghost.src = drag.list[(drag.i - dir + n) % n].dataset.full;
      }
      drag.v = (t.clientX - drag.lastX) / Math.max(1, e.timeStamp - drag.lastT);
      drag.lastX = t.clientX; drag.lastT = e.timeStamp;
      place(dx);
    }, { passive: false });
    var release = function (e) {
      if (!drag) return;
      var d = drag; drag = null;
      if (d.lock !== 'x') return;
      var dx = (e.changedTouches[0] || {}).clientX - d.x || 0;
      var commit = Math.abs(dx) > d.w * 0.25 || (Math.abs(d.v) > 0.45 && (d.v < 0) === (dx < 0));
      busy = true;
      main.style.transition = d.ghost.style.transition = EASE;
      main.style.transform = 'translate3d(' + (commit ? d.dir * d.w : 0) + 'px,0,0)';
      d.ghost.style.transform = 'translate3d(' + (commit ? 0 : -d.dir * d.w) + 'px,0,0)';
      setTimeout(function () {
        main.style.transition = 'none';
        main.style.transform = '';
        if (commit) d.list[(d.i - d.dir + d.list.length) % d.list.length].click();
        // keep the ghost over the frame until the swapped-in file has painted
        var done = function () { d.ghost.remove(); main.style.transition = ''; busy = false; };
        (commit && main.decode ? main.decode() : Promise.resolve()).then(done, done);
      }, 330);
    };
    stage.addEventListener('touchend', release, { passive: true });
    stage.addEventListener('touchcancel', release, { passive: true });
  }

  function idsOf(thumb) {
    return (thumb.dataset.variants || '').trim().split(/\s+/).filter(Boolean);
  }

  // Keyword, not equality: the option value is "Aviator/Pilot" but the curated
  // list keys it "aviator". Same mapping the old theme used.
  function shapeKey(value) {
    var v = (value || '').toLowerCase();
    if (v.indexOf('round') > -1) return 'round';
    if (v.indexOf('oval') > -1) return 'oval';
    if (v.indexOf('aviat') > -1 || v.indexOf('pilot') > -1) return 'aviator';
    if (v.indexOf('geometric') > -1) return 'geometric';
    if (v.indexOf('rect') > -1) return 'rectangle';
    if (v.indexOf('custom') > -1) return 'custom';
    return null;
  }

  function showPhotoSet(siblingIds, shapeValue) {
    if (!thumbWrap) return null;
    var thumbs = Array.from(thumbWrap.querySelectorAll('.thumb'));
    var curated = thumbs.some(function (t) { return t.dataset.shape; });
    var hits;
    if (curated) {
      hits = thumbs.filter(function (t) { return t.dataset.shape === shapeKey(shapeValue); });
      // shape the curated list does not cover (Custom Design): fall back to the
      // product's own images, which are rendered after the curated ones
      if (!hits.length) hits = thumbs.filter(function (t) { return !t.dataset.shape; });
    } else {
      hits = thumbs.filter(function (t) {
        return idsOf(t).some(function (id) { return siblingIds.indexOf(id) > -1; });
      });
    }
    // nothing attached for this shape — the whole gallery rather than an empty rail
    thumbs.forEach(function (t) { t.hidden = hits.length ? hits.indexOf(t) < 0 : false; });
    thumbWrap.classList.toggle('is-filtered', hits.length > 0);
    return hits[0] || null;
  }

  // Cross-fade rather than a hard src swap: the new file is decoded off-screen
  // first, so the frame never flashes empty between shapes.
  function setMain(src) {
    if (!main || !src || main.dataset.showing === src) return;
    main.dataset.showing = src;
    var next = new Image();
    next.onload = next.onerror = function () {
      main.removeAttribute('srcset');   // srcset wins over src, so the swap needs it gone
      main.removeAttribute('sizes');
      main.src = src;
      main.classList.remove('is-swapping');
    };
    main.classList.add('is-swapping');
    next.src = src;
    if (thumbWrap) {
      thumbWrap.querySelectorAll('.thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.full === src);
      });
    }
  }

  // variant selection
  var dataEl = document.getElementById('variant-data');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  var idField = document.getElementById('variant-id');

  function chosen() {
    return Array.from(form.querySelectorAll('.opt')).map(function (f) {
      var picked = f.querySelector('.opt__input:checked');
      return picked ? picked.value : null;
    });
  }

  // Only the options the shopper can actually see constrain a variant. Power and
  // lens are rendered hidden and answered in the wizard, so pinning them here
  // made every other shape look sold out: the shape was in stock, just not in
  // the lens value that happened to be checked.
  function visibleOnly(want) {
    var fields = Array.from(form.querySelectorAll('.opt'));
    return want.map(function (val, i) { return fields[i] && fields[i].hidden ? null : val; });
  }

  var stockline = form.querySelector('[data-stockline]');
  var stocktext = form.querySelector('[data-stockline-text]');
  var lowAt = stockline ? parseInt(stockline.dataset.low, 10) || 0 : 0;

  // A value is sold out only in the context of the OTHER picks: "Oval" can be
  // gone in black and in stock in tortoise. So every value is tested against the
  // current selection with its own index swapped in.
  function markSoldOut() {
    var want = visibleOnly(chosen());
    form.querySelectorAll('.opt').forEach(function (f, i) {
      if (f.hidden) return;
      f.querySelectorAll('.opt__input').forEach(function (input) {
        var trial = want.slice();
        trial[i] = input.value;
        var ok = variants.some(function (v) {
          return v.available && trial.every(function (val, j) {
            return val === null || v.options[j] === val;
          });
        });
        var pill = f.querySelector('.opt__pill[for="' + input.id + '"]');
        if (pill) pill.classList.toggle('is-oos', !ok);
      });
    });
  }

  function setStock(match) {
    if (!stockline || !stocktext) return;
    var out = !match || !match.available;
    var qty = match && match.inventory_management ? match.inventory_quantity : null;
    var low = !out && qty !== null && lowAt > 0 && qty > 0 && qty <= lowAt;
    stockline.classList.toggle('stockline--out', out);
    stockline.classList.toggle('stockline--low', low);
    stocktext.textContent = out ? 'Sold out'
      : low ? 'Only ' + qty + ' left'
      : (qty !== null && qty > 0) ? qty + ' in stock'
      : 'In stock';
  }

  function setCta(match) {
    var cta = form.querySelector('.buybox__cta');
    if (!cta || cta.tagName === 'A') return;
    if (!cta.dataset.label) cta.dataset.label = cta.textContent.trim();
    var out = !match || !match.available;
    cta.disabled = out;
    cta.textContent = out ? 'Sold out' : cta.dataset.label;
  }

  function syncVariant() {
    var want = chosen();
    if (!want.length || !variants.length) return;
    // Candidates are everything matching what is on screen. An available one
    // wins: the hidden lens option should not be able to park the form on a
    // sold-out combination the shopper cannot see or change.
    var shown = visibleOnly(want);
    var candidates = variants.filter(function (v) {
      return shown.every(function (val, i) { return val === null || v.options[i] === val; });
    });
    var match = candidates.find(function (v) { return v.available; }) || candidates[0];
    markSoldOut();
    setStock(match);
    setCta(match);
    // Group on the shape, not the exact variant: the lens choice must not change
    // the photos. The shape is the first option still shown on the page — the
    // power/lens ones are rendered hidden, so they are skipped here too.
    var axis = Array.from(form.querySelectorAll('.opt')).findIndex(function (f) { return !f.hidden; });
    var siblings = axis < 0 ? [] : variants
      .filter(function (v) { return v.options[axis] === want[axis]; })
      .map(function (v) { return String(v.id); });

    var lead = showPhotoSet(siblings, axis < 0 ? '' : want[axis]);
    var featured = match && match.featured_image ? match.featured_image.src : null;
    // Galaxsee (has the pager) shows fixed empty-frame shots; never swap in a variant photo
    setMain((lead && lead.dataset.full) || (pager ? null : featured));
    if (!match) return;
    idField.value = match.id;
    // keep the hidden option radios in step with the variant that actually won
    form.querySelectorAll('.opt').forEach(function (f, i) {
      if (!f.hidden) return;
      var input = f.querySelector('.opt__input');
      if (input) input.value = match.options[i];
    });
    var url = new URL(window.location);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url);
  }
  form.addEventListener('change', function (e) {
    if (e.target.classList.contains('opt__input')) syncVariant();
  });
  if (variants.length) syncVariant();

  // ---------- quantity stepper ----------
  var qtyInput = form.querySelector('[data-qty-input]');
  if (qtyInput) {
    form.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty]');
      if (!step) return;
      var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(step.dataset.qty, 10);
      qtyInput.value = Math.max(1, next);
    });
    // typing "0" or clearing the field would post an invalid line
    qtyInput.addEventListener('change', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    });
  }

  // ---------- contact lenses: per-eye power ----------
  var cl = form.querySelector('[data-contact-power]');
  if (cl) {
    var right = cl.querySelector('[data-cl-right]');
    var left = cl.querySelector('[data-cl-left]');
    var same = cl.querySelector('[data-cl-same]');
    var later = cl.querySelector('[data-cl-later]');

    // Disabled fields are not posted, so exactly one of "power now" / "power
    // later" ever reaches the cart — no contradictory pair of properties.
    function setMode(mode) {
      var now = mode !== 'later';
      cl.querySelectorAll('[data-cl-panel]').forEach(function (p) {
        p.hidden = (p.dataset.clPanel === 'later') === now;
      });
      right.disabled = left.disabled = !now;
      if (later) {
        later.disabled = now;
        later.value = now ? '' : 'Get a call/WhatsApp after the order is placed';
      }
      mirror();
    }
    function mirror() {
      if (!same.checked || left.disabled) return;
      left.value = right.value;
    }

    cl.addEventListener('change', function (e) {
      if (e.target.name === 'cl-mode') { setMode(e.target.value); return; }
      if (e.target === same) { left.parentElement.classList.toggle('is-off', same.checked); mirror(); return; }
      if (e.target === right) mirror();
    });
    cl.addEventListener('click', function (e) {
      var step = e.target.closest('[data-cl-qty]');
      if (!step) return;
      var field = cl.querySelector('[data-cl-qtyfield]');
      field.value = Math.max(1, (Number(field.value) || 1) + Number(step.dataset.clQty));
    });

    left.parentElement.classList.toggle('is-off', same.checked);
    setMode('now');
  }

  // ---------- reel sound ----------
  // Autoplay is only allowed while muted, so the reel starts silent and the
  // toggle is the shopper's opt-in. Pausing it off-screen stops a voiceover
  // following them down the page after they unmuted it.
  var reel = document.querySelector('[data-reel]');
  var soundBtn = document.querySelector('[data-reel-sound]');
  if (reel && soundBtn) {
    soundBtn.addEventListener('click', function () {
      reel.muted = !reel.muted;
      soundBtn.setAttribute('aria-pressed', String(!reel.muted));
      soundBtn.setAttribute('aria-label', reel.muted ? 'Unmute video' : 'Mute video');
      if (!reel.muted) reel.play();
    });
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reel.play(); }
        else if (!reel.muted) { reel.pause(); }
      });
    }, { threshold: 0.25 }).observe(reel);
  }

  // sticky buy bar — appears once the main CTA has scrolled out of view, and
  // steps aside again at the end of the page so it never covers the footer.
  var bar = document.querySelector('[data-sticky-buy]');
  var cta = form.querySelector('.buybox__cta');
  if (bar && cta) {
    var ctaGone = false;
    var atEnd = false;
    function paint() { bar.classList.toggle('is-up', ctaGone && !atEnd); }

    new IntersectionObserver(function (entries) {
      ctaGone = !entries[0].isIntersecting;
      paint();
    }, { threshold: 0 }).observe(cta);

    // Both tails are watched, not just the first one found. Watching only the
    // recently-viewed strip meant the bar hid over it and then came straight
    // back once it scrolled past — on top of the footer, which is the one place
    // it must never be.
    var inEnd = new Set();
    var tailIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) inEnd.add(e.target); else inEnd.delete(e.target);
      });
      atEnd = inEnd.size > 0;
      paint();
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

    [document.querySelector('[data-recent-section]'), document.querySelector('.ftr')]
      .forEach(function (t) { if (t) tailIo.observe(t); });

    bar.querySelector('[data-sticky-cta]').addEventListener('click', function () {
      cta.click();
      cta.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // lens wizard
  // inside the form on product pages; a sibling tied by form= in the customiser
  var lens = form.querySelector('[data-lens]') || document.querySelector('[data-lens]');
  if (!lens) return;
  var step = 1;
  var last = lens.querySelectorAll('.lens__pane').length;
  // the prescription block only counts when the order actually went through step 3
  var rx = window.AecoRx(lens, form, function () { return step === last && !isZero(); });

  function render() {
    var pane = null;
    lens.querySelectorAll('.lens__pane').forEach(function (p) {
      var on = Number(p.dataset.pane) === step;
      p.classList.toggle('is-active', on);
      if (on) pane = p;
    });
    lens.querySelectorAll('.lens__step').forEach(function (s) {
      s.classList.toggle('is-active', Number(s.dataset.stepDot) <= step);
    });
    var title = lens.querySelector('[data-lens-title]');
    if (title && pane && pane.dataset.title) title.textContent = pane.dataset.title;
    lens.querySelector('[data-lens-back]').hidden = step === 1;
    var endsHere = step === last || (step === 2 && isZero() && !isTinted());
    lens.querySelector('[data-lens-next]').textContent = endsHere ? 'Add to cart' : 'Continue';

    // step 3: tint chart + shade box for tinted lenses; prescription fields only with power
    var tintBox = lens.querySelector('[data-lens-tint]');
    var tintIn = lens.querySelector('[data-tint-input]');
    var rxBox = lens.querySelector('[data-lens-rx]');
    if (tintBox) tintBox.hidden = !isTinted();
    if (tintIn) tintIn.disabled = !isTinted();          // disabled = not sent with the order
    if (rxBox) rxBox.hidden = isZero();
    if (step === last && title) title.textContent = isZero() ? 'Tint details' : (isTinted() ? 'Tint & Prescription' : pane.dataset.title);

    // "picked / total" for the pane's options; the prescription pane has none
    var count = lens.querySelector('[data-lens-count]');
    if (count && pane) {
      var opts = Array.from(pane.querySelectorAll('.lensopt')).filter(function (o) { return !o.hidden; });
      var at = opts.indexOf(pane.querySelector('.lensopt.is-picked'));
      count.hidden = !opts.length;
      count.textContent = (at + 1 || 1) + ' / ' + opts.length;
    }
  }

  // Which lenses each power type offers, matched on the lens names. "Frame Only" is
  // never offered. Zero power: blue-filter, tinted, photochromatic, no prescription.
  function powerType() {
    var p = lens.querySelector('[data-pick="power_type"].is-picked');
    return p ? p.dataset.value : '';
  }
  function isZero() { return /zero power/i.test(powerType()); }
  function isTinted() {
    var l = lens.querySelector('[data-pick="lens"].is-picked');
    return !!l && /tint/i.test(l.dataset.value);
  }
  function lensFits(name) {
    var n = name.toLowerCase(), p = powerType().toLowerCase();
    if (/frame only/.test(n)) return false;
    if (/zero power/.test(p)) return /zero power|tinted|photochrom/.test(n);
    if (/progressive|bifocal/.test(p)) return /progressive/.test(n);
    return !/zero power|progressive/.test(n);          // with power
  }
  function filterLenses() {
    var cards = Array.from(lens.querySelectorAll('[data-pick="lens"]'));
    cards.forEach(function (c) { c.hidden = !lensFits(c.dataset.value); });
    var picked = lens.querySelector('[data-pick="lens"].is-picked');
    if (!picked || picked.hidden) {
      var first = cards.find(function (c) { return !c.hidden; });
      cards.forEach(function (c) { c.classList.toggle('is-picked', c === first); });
    }
    syncProps();
  }

  function syncProps() {
    lens.querySelectorAll('[data-prop]').forEach(function (input) {
      var picked = lens.querySelector('[data-pick="' + input.dataset.prop + '"].is-picked');
      input.value = picked ? picked.dataset.value : '';
    });
  }

  function open() {
    lens.hidden = false;
    document.body.style.overflow = 'hidden';
    step = 1;
    render();
    requestAnimationFrame(function () { lens.classList.add('is-open'); });  // let the panel paint off-screen first
  }
  function close() {
    lens.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { if (!lens.classList.contains('is-open')) lens.hidden = true; }, 350);
  }

  // The lens is a real variant option on these products (each lens has its own
  // price), but its radios are hidden, so the wizard's answer has to pick the
  // variant: same visible choices (the shape), and a hidden option whose value
  // contains the picked lens's name ("Progressive" -> "Bluefilter Progressive
  // Lens (...)"). Products without a lens option keep the variant they had.
  function lensVariant(name) {
    var n = (name || '').toLowerCase().trim();
    if (!n || !variants.length) return null;
    var shown = visibleOnly(chosen());
    var best = null;
    variants.forEach(function (v) {
      if (!shown.every(function (val, i) { return val === null || v.options[i] === val; })) return;
      var hit = v.options.some(function (o, i) { return shown[i] === null && String(o).toLowerCase().indexOf(n) > -1; });
      if (hit && (!best || (!best.available && v.available))) best = v;
    });
    return best;
  }

  // requestSubmit (not submit) so the drawer's submit listener runs.
  function buy() {
    var picked = lens.querySelector('[data-prop="lens"]').value;
    var v = lensVariant(picked);
    if (v && idField) idField.value = v.id;
    form.requestSubmit();
  }

  // zoom lightbox for the lens photos
  var zoomBox = lens.querySelector('[data-zoom-box]');
  var zoomImg = zoomBox && zoomBox.querySelector('[data-zoom-img]');
  function closeZoom() {
    if (!zoomBox) return;
    zoomBox.classList.remove('is-open');
    setTimeout(function () { zoomBox.hidden = true; }, 250);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lens-open]')) { open(); return; }
    if (e.target.closest('[data-lens-close]')) { close(); return; }

    if (zoomBox && zoomBox.contains(e.target)) { closeZoom(); return; }
    var shot = e.target.closest('[data-zoom]');
    if (shot && zoomImg) {
      zoomImg.src = shot.dataset.zoom;
      zoomBox.hidden = false;
      requestAnimationFrame(function () { zoomBox.classList.add('is-open'); });
      return;
    }

    var opt = e.target.closest('.lensopt');
    if (opt) {
      opt.parentElement.querySelectorAll('.lensopt').forEach(function (o) {
        o.classList.toggle('is-picked', o === opt);
      });
      syncProps();
      render();
      return;
    }

    if (e.target.closest('[data-lens-back]')) { step = Math.max(1, step - 1); render(); return; }

    if (e.target.closest('[data-lens-next]')) {
      syncProps();
      // step 1 -> lenses for that power type; zero power then buys without a prescription
      if (step === 1) { filterLenses(); step = 2; render(); return; }
      if (step === 2 && isZero() && !isTinted()) { buy(); return; }
      if (step >= last) {
        var tintIn = lens.querySelector('[data-tint-input]'), tintErr = lens.querySelector('[data-tint-err]');
        if (isTinted() && tintIn && !tintIn.value.trim()) { if (tintErr) tintErr.hidden = false; tintIn.focus(); return; }
        if (tintErr) tintErr.hidden = true;
        if (!isZero() && rx && !rx.check()) return;
        buy(); return;
      }
      step += 1;
      render();
    }
  }, { signal: ac.signal });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && zoomBox && !zoomBox.hidden) { closeZoom(); return; }
    if (e.key === 'Escape' && !lens.hidden) { close(); return; }
    // the step-2 cards are divs (they hold their own zoom button), so wire the keys
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('lensopt')) {
      e.preventDefault();
      e.target.click();
    }
  }, { signal: ac.signal });

  render();
}
initProduct();
document.addEventListener('shopify:section:load', function (e) {
  if (e.target.querySelector('#product-form')) initProduct();
});

// ---------- comet scrollbar ----------
// Overlay replacement for the native scrollbar (see theme.css for why it is
// gone). A fixed-length comet whose head tracks scroll progress, draggable so
// removing the native thumb does not cost the drag-to-scroll it provided.
(function () {
  if (window.matchMedia('(pointer: coarse)').matches) return;

  var comet = document.createElement('div');
  comet.className = 'comet';
  comet.setAttribute('aria-hidden', 'true');
  var head = document.createElement('span');
  head.className = 'comet__head';
  comet.appendChild(head);
  document.body.appendChild(comet);

  var track = 0;   // px the head can travel
  var max = 0;     // px the page can scroll

  function measure() {
    max = document.documentElement.scrollHeight - window.innerHeight;
    track = window.innerHeight - head.offsetHeight;
    comet.classList.toggle('is-ready', max > 40 && track > 0);
    place();
  }

  // CSS derives both the head position and the tail length from --p
  function place() {
    if (max <= 0 || track <= 0) return;
    var p = Math.min(1, Math.max(0, window.scrollY / max));
    comet.style.setProperty('--p', p);
  }

  window.addEventListener('scroll', place, { passive: true });
  window.addEventListener('resize', measure);
  // sections load lazily and the cart drawer changes page height
  if (window.ResizeObserver) new ResizeObserver(measure).observe(document.body);
  measure();

  head.addEventListener('pointerdown', function (e) {
    if (track <= 0) return;
    e.preventDefault();
    var startY = e.clientY;
    var startScroll = window.scrollY;
    document.documentElement.classList.add('is-cometdrag');

    function move(ev) {
      window.scrollTo(0, startScroll + ((ev.clientY - startY) / track) * max);
    }
    function up() {
      document.documentElement.classList.remove('is-cometdrag');
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    }
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  });
})();

// ---------- recently viewed ----------
(function () {
  var KEY = 'aeco:recent';
  var handle = document.body.dataset.productHandle;
  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (err) { list = []; }

  if (handle) {
    list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 8);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (err) { /* private mode */ }
  }

  var mount = document.querySelector('[data-recent]');
  if (!mount) return;
  var others = list.filter(function (h) { return h !== handle; }).slice(0, 4);
  if (!others.length) { mount.closest('[data-recent-section]').hidden = true; return; }

  Promise.all(others.map(function (h) {
    return fetch(window.Shopify.routes.root + 'products/' + h + '?section_id=' + mount.dataset.recent)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  })).then(function (chunks) {
    var html = chunks.join('');
    if (!html.trim()) { mount.closest('[data-recent-section]').hidden = true; return; }
    mount.innerHTML = html;
    mount.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();

// ---------- cart drawer ----------
(function () {
  var root = (window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function open() { document.body.classList.add('cart-open'); }
  function close() { document.body.classList.remove('cart-open'); }

  function refresh() {
    return fetch(root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var current = document.getElementById('shopify-section-cart-drawer');
        var fresh = new DOMParser().parseFromString(html, 'text/html')
          .getElementById('shopify-section-cart-drawer');
        if (!current || !fresh) return;
        current.replaceWith(fresh);
        var badge = document.querySelector('[data-cart-count]');
        var count = fresh.querySelector('[data-cart-drawer]').dataset.count;
        if (badge) { badge.textContent = count; badge.hidden = count === '0'; }
      });
  }

  // for flows that post to /cart/add.js themselves (the Galaxsee lens screen)
  window.AecoCart = { open: open, refresh: refresh };

  // Add to cart without leaving the page.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    if (busy) return;
    busy = true;

    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        var wizard = document.querySelector('[data-lens]');
        if (wizard) { wizard.classList.remove('is-open'); wizard.hidden = true; document.body.style.overflow = ''; }
        return refresh().then(open);
      })
      .catch(function () { form.submit(); })   // network/inventory error: let Shopify render it
      .finally(function () { busy = false; });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { open(); refresh(); return; }
    if (e.target.closest('[data-cart-close]')) { close(); return; }

    var step = e.target.closest('[data-cart-change]');
    if (step && !busy) {
      busy = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(step.dataset.line), quantity: Number(step.dataset.qty) })
      }).then(refresh).finally(function () { busy = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('cart-open')) close();
  });
})();

// ---------- search overlay ----------
// Predictive search in a panel instead of a page load. Enter still submits the
// form to /search, so the full results page stays one keystroke away.
(function () {
  var box = document.querySelector('[data-search]');
  if (!box) return;

  var root = (window.Shopify.routes && window.Shopify.routes.root) || '/';
  var input = box.querySelector('[data-search-input]');
  var out = box.querySelector('[data-search-results]');
  var timer = null;
  var seq = 0;          // only the newest request may paint

  function open() {
    box.hidden = false;
    document.body.classList.add('search-open');
    requestAnimationFrame(function () {
      box.classList.add('is-open');
      input.focus();
      input.select();
    });
  }
  function close() {
    box.classList.remove('is-open');
    document.body.classList.remove('search-open');
    setTimeout(function () { if (!box.classList.contains('is-open')) box.hidden = true; }, 250);
  }

  // suggest.json returns the price in cents as a string; the shop's money_format
  // ("₹{{amount}}") comes through on the panel so the currency matches the site.
  var moneyFmt = box.dataset.money || '{{amount}}';
  function money(cents) {
    var n = Number(cents) / 100;
    var amount = n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function paint(items, term) {
    if (!items.length) {
      out.innerHTML = '<p class="sq__empty">No matches for “' + term.replace(/[<>&]/g, '') + '”.</p>';
      return;
    }
    out.innerHTML = items.map(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img src="' + p.featured_image.url + '&width=160" alt="" width="60" height="60" loading="lazy">'
        : '<span class="sq__blank"></span>';
      return '<a class="sq__hit" href="' + p.url + '">' + img +
        '<span class="sq__hitinfo"><span class="sq__hitname">' + p.title + '</span>' +
        '<span class="sq__hitprice">' + (p.price != null ? money(p.price) : '') + '</span></span></a>';
    }).join('') +
    '<a class="sq__all" href="' + root + 'search?q=' + encodeURIComponent(term) + '">See all results</a>';
  }

  function run() {
    var term = input.value.trim();
    if (term.length < 2) { out.innerHTML = ''; return; }
    var mine = ++seq;
    fetch(root + 'search/suggest.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (mine !== seq) return;                       // a newer keystroke won
        paint((data.resources.results.products || []), term);
      })
      .catch(function () { if (mine === seq) out.innerHTML = ''; });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]')) { close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !box.hidden) close();
  });
  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(run, 220);
  });
})();

// ---------- PDP scroll story ----------
// Sticky image on the left, steps on the right. A full-height band across the
// middle of the viewport decides which step is "current"; entering it flips the
// class and CSS cross-fades the matching layer. No scroll listener.
(function () {
  document.querySelectorAll('[data-pdp-story]').forEach(function (root) {
    var steps = root.querySelectorAll('[data-pdp-story-step]');
    var layers = root.querySelectorAll('[data-pdp-story-layer]');
    if (steps.length < 2 || !layers.length) return;

    function show(i) {
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      layers.forEach(function (l, n) { l.classList.toggle('is-active', n === i); });
    }

    // -45%/-45% leaves a thin band at the viewport's middle: whichever step
    // crosses it wins, so scrolling back up reverses cleanly. A threshold-based
    // observer instead picks the tallest visible step, which sticks on the long
    // ones and skips the short ones entirely.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) show(Number(e.target.dataset.pdpStoryStep));
      });
    }, { rootMargin: '-45% 0px -45% 0px' });

    steps.forEach(function (s) { io.observe(s); });
  });
})();

/* Hotspots: one pin open at a time, closed by an outside tap or Escape.
   Phones show the open pin's text in a docked card under the frame; the first pin
   opens on load, and tapping its × closes it. */
(function () {
  var phone = window.matchMedia('(max-width:640px)');
  function closeAll(stage, except) {
    stage.querySelectorAll('.hs__pin[open]').forEach(function (p) { if (p !== except) p.open = false; });
  }
  function sync(stage) {
    var dock = stage.parentElement.querySelector('[data-hs-dock]');
    if (!dock) return;
    var pop = stage.querySelector('.hs__pin[open] .hs__pop');
    dock.innerHTML = pop ? pop.innerHTML : '';
    dock.hidden = !pop;
  }
  function keepOne(stage) {
    if (phone.matches && !stage.querySelector('.hs__pin[open]')) {
      var first = stage.querySelector('.hs__pin');
      if (first) first.open = true;
    }
  }
  document.addEventListener('toggle', function (e) {
    var pin = e.target;
    if (!pin.classList || !pin.classList.contains('hs__pin')) return;
    var stage = pin.closest('[data-hotspots]');
    if (pin.open) closeAll(stage, pin);
    sync(stage);   // tapping the open pin's × closes it and hides the card
  }, true);
  document.addEventListener('click', function (e) {
    if (phone.matches || e.target.closest('.hs__pin')) return;
    document.querySelectorAll('[data-hotspots]').forEach(function (s) { closeAll(s); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !phone.matches) document.querySelectorAll('[data-hotspots]').forEach(function (s) { closeAll(s); });
  });
  document.querySelectorAll('[data-hotspots]').forEach(keepOne);
  phone.addEventListener('change', function () {
    document.querySelectorAll('[data-hotspots]').forEach(function (s) { keepOne(s); sync(s); });
  });
})();

/* Galaxsee pre-order: Liquid decides on render, this re-checks in the browser so a
   cached page stops saying "pre-order" on the ship date (midnight IST). */
(function () {
  document.querySelectorAll('[data-preorder-until]').forEach(function (el) {
    var until = Date.parse(el.dataset.preorderUntil + 'T00:00:00+05:30');
    if (isNaN(until) || Date.now() < until) return;
    if (el.classList.contains('gx-preorder')) { el.remove(); return; }
    delete el.dataset.preorder;
    el.querySelectorAll('[data-preorder-only]').forEach(function (n) { n.remove(); });
  });
})();

/* Galaxsee frame picker (Black | Transparent): shows that frame's photo and
   points "Start Customizing" at it, so the customiser skips the frame step. */
(function () {
  var box = document.querySelector('[data-gx-frame]');
  if (!box) return;
  var cta = document.querySelector('[data-gx-cta]');
  box.addEventListener('click', function (e) {
    var opt = e.target.closest('.gxframe__opt');
    if (!opt) return;
    box.querySelectorAll('.gxframe__opt').forEach(function (o) {
      var on = o === opt;
      o.classList.toggle('is-on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    if (cta) cta.href = cta.href.replace(/([?&]frame=)[^&]*/, '$1' + opt.dataset.frame);
    var thumbs = document.querySelectorAll('[data-thumbs] .thumb');
    var t = thumbs[Number(opt.dataset.shot)];
    if (t) t.click();
  });
})();


// ---------- product-page Instagram row: tap wakes one embed (see theme.css) ----------
document.querySelectorAll('.ig__row').forEach(function (row) {
  var sleep = function () {
    row.querySelectorAll('.ig__tile.is-live').forEach(function (t) { t.classList.remove('is-live'); });
  };
  row.addEventListener('click', function (e) {
    var tile = e.target.closest('.ig__tile');
    if (!tile || tile.classList.contains('is-live') || !tile.querySelector('iframe')) return;
    sleep();
    tile.classList.add('is-live');
  });
  row.addEventListener('scroll', sleep, { passive: true });
});
